import { Navigate, useSearchParams } from "react-router-dom";
import { useCompanyMode } from "@/hooks/useCompanyMode";
import { isSafeModeActive } from "@/lib/audit-mode";

/**
 * Wraps a /dash/* route so audit-mode tenants get bounced to /dash/verify.
 * HomeGate already covers the index route, but sibling routes (e.g. /dash/home,
 * /dash/developers) need their own gate or they leak full Phase 2 chrome.
 *
 * Reads dashboardMode from CompanyModeProvider (loaded by DashV2Layout).
 * ?safe=1 (sticky in sessionStorage) is the rollback escape hatch.
 */
export function AuditModeRedirect({ children }: { children: React.ReactNode }) {
  const { dashboardMode } = useCompanyMode();
  const [searchParams] = useSearchParams();
  const safeMode = isSafeModeActive(searchParams);

  if (dashboardMode === "audit" && !safeMode) {
    return <Navigate to="/dash/verify" replace />;
  }

  return <>{children}</>;
}
